import { slideExpand, slideCollapse, slideStop } from '@utils/slide-anim';
class IndexSection {
    constructor(element) {
        if (!element)
            throw new Error('undefined element');
        this.element = element;
        this.init();
    }
    init() {
        var _a;
        this.buttonEl = this.element.querySelector('.index-section__heading button');
        (_a = this.buttonEl) === null || _a === void 0 ? void 0 : _a.addEventListener('click', this.handleButtonClick.bind(this));
    }
    handleButtonClick() {
        this.toggle(!this.expanded);
    }
    toggle(expanded) {
        var _a, _b, _c;
        if (expanded === this.expanded) {
            return;
        }
        (_a = this.buttonEl) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-expanded', `${expanded}`);
        const controlsIds = (_c = (_b = this.buttonEl) === null || _b === void 0 ? void 0 : _b.getAttribute('aria-controls')) === null || _c === void 0 ? void 0 : _c.split(' ');
        controlsIds === null || controlsIds === void 0 ? void 0 : controlsIds.forEach((id) => {
            const contentEl = document.getElementById(id);
            if (contentEl) {
                if (expanded) {
                    contentEl.removeAttribute('hidden');
                    contentEl.style.display = 'none';
                    contentEl.style.opacity = '';
                    slideStop(contentEl);
                    void slideExpand(contentEl);
                }
                else {
                    contentEl.style.opacity = '0';
                    slideStop(contentEl);
                    void slideCollapse(contentEl).then(() => {
                        contentEl.setAttribute('hidden', '');
                    });
                }
            }
        });
    }
    get expanded() {
        var _a;
        return ((_a = this.buttonEl) === null || _a === void 0 ? void 0 : _a.getAttribute('aria-expanded')) === 'true';
    }
    open() {
        this.toggle(true);
    }
    close() {
        this.toggle(false);
    }
}
document.querySelectorAll('.index-section').forEach((sectionEl) => {
    new IndexSection(sectionEl);
});
